import { IFormConfigurationContext } from '@wyz/types';
import { UseQueryResult } from '@wyz/utils';
import { createContext } from 'react';
import {
  IRimOptionItem,
  ITyreCountOptionItem,
  IVehicleTypeGroupList,
  IVehicleTypeGroupsOptionItem,
} from '~/common/types';
import { IPurchaseErrorResponse } from '~/purchase/types';

export type IFormContext = {
  mode: IFormConfigurationContext['mode'];
  vehicleTypeGroups: {
    optionItems: Array<IVehicleTypeGroupsOptionItem>;
  } & UseQueryResult<IVehicleTypeGroupList, IPurchaseErrorResponse>;
  rims: { optionItems: Array<IRimOptionItem> };
  tyreCounts: { optionItems: Array<ITyreCountOptionItem> };
};
export const FormContext = createContext<IFormContext | undefined>(undefined);
